import Vue from 'vue'
import Vuex from 'Vuex'
import user from './modules/user'
import history from './modules/history'
import book from './modules/book'
import category from './modules/category'
import system from './modules/system'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		user,
		history,
		book,
		category,
		system
	},
	getters,
	actions,
	mutations
})


// WEBPACK FOOTER //
// ./src/store/index.js